// extracted by mini-css-extract-plugin
export default {"heading":"HpHeading_heading__uJY9a","heading-vector":"HpHeading_heading-vector__qixBg","sub-heading":"HpHeading_sub-heading__Oyayb"};